(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.article__divider-wrap').forEach(function (wrap) {
      window.applyDashedLine(wrap);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after-slider"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.baf').forEach(function (container) {
      var handle = container.querySelector('.baf__handle');
      if (!handle) return;
      var dragging = false;

      function setPos(clientX) {
        var rect = container.getBoundingClientRect();
        var pct = Math.min(98, Math.max(2, (clientX - rect.left) / rect.width * 100));
        container.style.setProperty('--pos', pct + '%');
      }

      handle.addEventListener('mousedown', function (e) {
        dragging = true;
        e.preventDefault();
      });

      handle.addEventListener('touchstart', function (e) {
        dragging = true;
        e.preventDefault();
      }, { passive: false });

      document.addEventListener('mousemove', function (e) {
        if (dragging) setPos(e.clientX);
      });

      container.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        e.preventDefault();
        setPos(e.touches[0].clientX);
      }, { passive: false });

      document.addEventListener('mouseup', function () { dragging = false; });
      document.addEventListener('touchend', function () { dragging = false; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.blog-article').forEach(function (article) {
      var svg = window.applyDashedRect(article, 'dashed-border');
      article.addEventListener('mouseenter', function () { svg.style.opacity = '1'; });
      article.addEventListener('mouseleave', function () { svg.style.opacity = '0'; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var NS = 'http://www.w3.org/2000/svg';
    var drawer   = document.getElementById('cart-drawer');
    var body     = document.getElementById('cart-drawer-body');
    var foot     = document.getElementById('cart-drawer-foot');
    var closeBtn = drawer && drawer.querySelector('.cart-drawer__close');
    var backdrop = drawer && drawer.querySelector('.cart-drawer__backdrop');
    if (!drawer || !body || !foot) return;

    var currency = drawer.dataset.currency || 'USD';
    var i18n = {
      empty:    drawer.dataset.i18nEmpty    || 'Your cart is empty.',
      subtotal: drawer.dataset.i18nSubtotal || 'Subtotal',
      quantity: drawer.dataset.i18nQuantity || 'Qty',
      checkout: drawer.dataset.i18nCheckout || 'Checkout',
      remove:   drawer.dataset.i18nRemove   || 'Remove'
    };
    function formatMoney(cents) {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    }

    function buildDivider() {
      var wrap = document.createElement('div');
      wrap.className = 'cart-drawer__divider-wrap';
      wrap.setAttribute('aria-hidden', 'true');
      var svg = document.createElementNS(NS, 'svg');
      svg.classList.add('cart-drawer__divider');
      wrap.appendChild(svg);
      return wrap;
    }

    function drawDividers() {
      body.querySelectorAll('.cart-drawer__divider-wrap').forEach(function (wrap) {
        window.applyDashedLine(wrap);
      });
    }

    function updateHeaderCount(count) {
      var sup = document.getElementById('header-cart-count');
      if (!sup) return;
      if (count > 0) {
        sup.textContent = count;
        sup.removeAttribute('hidden');
      } else {
        sup.setAttribute('hidden', '');
      }
    }

    function buildCheckoutBorder(btn) {
      var svg = window.applyDashedRect(btn, 'dashed-border');
      btn.addEventListener('mouseenter', function () { svg.style.opacity = '1'; });
      btn.addEventListener('mouseleave', function () { svg.style.opacity = '0'; });
    }

    function buildItemEl(item) {
      var el = document.createElement('div');
      el.className = 'cart-drawer__item';
      el.dataset.key = String(item.key);
      el.innerHTML =
        '<a href="' + item.url + '" class="cart-drawer__item-img-wrap">' +
          '<img src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '" loading="lazy">' +
        '</a>' +
        '<div class="cart-drawer__item-info">' +
          '<a href="' + item.url + '" class="cart-drawer__item-name">' + item.product_title + '</a>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<span class="cart-drawer__item-sub">' + item.variant_title + '</span>' : '') +
          '<div class="cart-drawer__item-qty-row">' +
            '<span class="cart-drawer__item-qty-label">' + i18n.quantity + '</span>' +
            '<input class="cart-drawer__item-qty" type="number" value="' + item.quantity + '" min="0" data-key="' + item.key + '">' +
          '</div>' +
          '<button class="cart-drawer__item-remove" data-key="' + item.key + '" aria-label="' + i18n.remove + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3,6 5,6 21,6"/><path d="M19,6l-1,14H6L5,6"/><path d="M10,11v6"/><path d="M14,11v6"/><path d="M9,6V4h6v2"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</div>';
      return el;
    }

    function render(cart) {
      updateHeaderCount(cart.item_count);

      if (cart.item_count === 0) {
        body.innerHTML = '<p class="cart-drawer__empty">' + i18n.empty + '</p>';
        foot.setAttribute('hidden', '');
        return;
      }

      var emptyMsg = body.querySelector('.cart-drawer__empty');
      if (emptyMsg) emptyMsg.remove();

      /* Diff existing DOM against new cart by item key. Reusing item elements
         avoids re-decoding their <img> children — the source of the flicker. */
      var existingMap = {};
      body.querySelectorAll('.cart-drawer__item').forEach(function (el) {
        existingMap[el.dataset.key] = el;
      });

      var fragment = document.createDocumentFragment();
      cart.items.forEach(function (item, i) {
        if (i > 0) fragment.appendChild(buildDivider());
        var key = String(item.key);
        var el = existingMap[key];
        if (el) {
          var priceEl = el.querySelector('.cart-drawer__item-price');
          if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);
          var qtyEl = el.querySelector('.cart-drawer__item-qty');
          if (qtyEl && document.activeElement !== qtyEl) qtyEl.value = item.quantity;
        } else {
          el = buildItemEl(item);
        }
        fragment.appendChild(el);
      });

      while (body.firstChild) body.removeChild(body.firstChild);
      body.appendChild(fragment);
      drawDividers();

      var subtotalEl = foot.querySelector('.cart-drawer__subtotal-price');
      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(cart.total_price);
      } else {
        foot.removeAttribute('hidden');
        foot.innerHTML =
          '<div class="cart-drawer__subtotal">' +
            '<span>' + i18n.subtotal + '</span>' +
            '<span class="cart-drawer__subtotal-price">' + formatMoney(cart.total_price) + '</span>' +
          '</div>' +
          '<a href="/checkout" class="cart-drawer__checkout">' + i18n.checkout + '</a>';
        var checkoutBtn = foot.querySelector('.cart-drawer__checkout');
        if (checkoutBtn) buildCheckoutBorder(checkoutBtn);
      }
    }

    function changeQty(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(render);
    }

    /* Event delegation: bind ONCE on body, never duplicated across renders. */
    body.addEventListener('change', function (e) {
      if (e.target.classList.contains('cart-drawer__item-qty')) {
        changeQty(e.target.dataset.key, parseInt(e.target.value, 10) || 0);
      }
    });
    body.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-drawer__item-remove');
      if (btn) changeQty(btn.dataset.key, 0);
    });

    function refresh() {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(render);
    }

    window.CartDrawer = {
      open: function () {
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        refresh();
      },
      close: function () {
        drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      },
      refresh: refresh
    };

    if (closeBtn) closeBtn.addEventListener('click', window.CartDrawer.close);
    if (backdrop) backdrop.addEventListener('click', window.CartDrawer.close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        window.CartDrawer.close();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    /* ── Item dividers ── */
    document.querySelectorAll('.cart-page__divider-wrap').forEach(function (wrap) {
      window.applyDashedLine(wrap);
    });

    /* ── Checkout button dashed border ── */
    var checkout = document.querySelector('.cart-page__checkout');
    if (checkout) {
      var svg = window.applyDashedRect(checkout, 'dashed-border');
      checkout.addEventListener('mouseenter', function () { svg.style.opacity = '1'; });
      checkout.addEventListener('mouseleave', function () { svg.style.opacity = '0'; });
    }

    /* ── Qty auto-update on change ── */
    document.querySelectorAll('.cart-page__item-qty').forEach(function (input) {
      input.addEventListener('change', function () { input.closest('form').submit(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var NS = 'http://www.w3.org/2000/svg';
    var drawDashedEdge = window.drawDashedEdge;

    function renderBorder(item, svg) {
      var w = item.offsetWidth, h = item.offsetHeight;
      var media = item.querySelector('.collection-grid__media');
      var mediaH = media ? media.offsetHeight : 0;
      if (!w || !h) return;
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      svg.setAttribute('width', w + 2);
      svg.setAttribute('height', h + 2);
      drawDashedEdge(svg, 1,   1,   w+1, 1);
      drawDashedEdge(svg, w+1, 1,   w+1, h+1);
      drawDashedEdge(svg, w+1, h+1, 1,   h+1);
      drawDashedEdge(svg, 1,   h+1, 1,   1);
      drawDashedEdge(svg, 1, mediaH + 1, w+1, mediaH + 1);
    }

    document.querySelectorAll('.collection-grid__item').forEach(function (item) {
      var svg = document.createElementNS(NS, 'svg');
      svg.classList.add('collection-grid__border');
      item.appendChild(svg);
      renderBorder(item, svg);
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(function () { renderBorder(item, svg); }).observe(item);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diagonal-stack"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function layout() {
      document.querySelectorAll('.diagonal-stack').forEach(function (container) {
        var corner = parseFloat(container.dataset.corner) || 20;
        var aspect = parseFloat(container.dataset.aspect) || 0.75;
        var items = Array.from(container.querySelectorAll('.diagonal-stack__item'));
        var n = items.length;
        if (!n) return;

        var W = container.offsetWidth;
        var imgW = (W + (n - 1) * corner) / n;
        var imgH = imgW * aspect;

        items.forEach(function (item, i) {
          item.style.left   = (i * (imgW - corner)) + 'px';
          item.style.top    = (i * (imgH - corner)) + 'px';
          item.style.width  = imgW + 'px';
          item.style.height = imgH + 'px';
        });

        container.style.height = (n * imgH - (n - 1) * corner) + 'px';
      });
    }

    layout();
    window.addEventListener('resize', layout);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dvd-bounce"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.dvd-bounce').forEach(function (box) {
      var els = Array.from(box.querySelectorAll('.dvd-bounce__item'));
      if (!els.length) return;

      var speed = parseFloat(box.dataset.speed) || 3;

      var balls = els.map(function (el, i) {
        var angle = (i / els.length) * Math.PI * 2 + 0.4;
        return {
          el: el,
          x: 60 + i * 90,
          y: 60 + i * 70,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          w: 0,
          h: 0,
          mass: 1
        };
      });

      function measure() {
        balls.forEach(function (b) {
          if (b.el.offsetWidth)  b.w = b.el.offsetWidth;
          if (b.el.offsetHeight) b.h = b.el.offsetHeight;
          b.mass = b.w * b.h || 1;
        });
      }

      measure();
      els.forEach(function (el) {
        var img = el.querySelector('img');
        if (img && !img.complete) img.addEventListener('load', measure, { once: true });
      });
      if (typeof ResizeObserver !== 'undefined') new ResizeObserver(measure).observe(box);

      function tick() {
        var bw = box.offsetWidth;
        var bh = box.offsetHeight;

        /* ── Move + wall bounce ── */
        balls.forEach(function (b) {
          if (!b.w || !b.h) return;
          b.x += b.vx;
          b.y += b.vy;

          var hitX = false, hitY = false;
          if (b.x + b.w >= bw) { b.x = bw - b.w; b.vx = -Math.abs(b.vx); hitX = true; }
          if (b.x <= 0)        { b.x = 0;         b.vx =  Math.abs(b.vx); hitX = true; }
          if (b.y + b.h >= bh) { b.y = bh - b.h;  b.vy = -Math.abs(b.vy); hitY = true; }
          if (b.y <= 0)        { b.y = 0;          b.vy =  Math.abs(b.vy); hitY = true; }

          if (hitX || hitY) {
            b.el.style.filter = 'brightness(3) saturate(2)';
            setTimeout(function () { b.el.style.filter = ''; }, 180);
          }

          b.el.style.transform = 'translate(' + b.x + 'px, ' + b.y + 'px)';
        });

        /* ── Ball–ball collision — 3 resolution passes ── */
        for (var pass = 0; pass < 3; pass++) {
          for (var i = 0; i < balls.length; i++) {
            for (var j = i + 1; j < balls.length; j++) {
              var a = balls[i], b = balls[j];
              if (!a.w || !a.h || !b.w || !b.h) continue;

              var ox = Math.min(a.x + a.w, b.x + b.w) - Math.max(a.x, b.x);
              var oy = Math.min(a.y + a.h, b.y + b.h) - Math.max(a.y, b.y);
              if (ox <= 0 || oy <= 0) continue;

              /* Collision normal — axis of minimum overlap, direction from A to B */
              var nx, ny, half;
              if (ox < oy) {
                nx   = (a.x + a.w * 0.5 < b.x + b.w * 0.5) ? 1 : -1;
                ny   = 0;
                half = ox * 0.5;
                a.x -= nx * half;
                b.x += nx * half;
              } else {
                nx   = 0;
                ny   = (a.y + a.h * 0.5 < b.y + b.h * 0.5) ? 1 : -1;
                half = oy * 0.5;
                a.y -= ny * half;
                b.y += ny * half;
              }

              /* Relative velocity along normal (positive = A approaching B) */
              var dvn = (a.vx - b.vx) * nx + (a.vy - b.vy) * ny;
              if (dvn <= 0) continue; /* already separating */

              /* Mass-weighted elastic impulse:
                 vA -= 2*mb/(ma+mb) * dvn * n
                 vB += 2*ma/(ma+mb) * dvn * n  */
              var ma = a.mass, mb = b.mass, total = ma + mb;
              var fa = 2 * dvn * mb / total;
              var fb = 2 * dvn * ma / total;
              a.vx -= fa * nx;  a.vy -= fa * ny;
              b.vx += fb * nx;  b.vy += fb * ny;
            }
          }
        }

        /* ── Speed floor — prevent numerical slow-down ── */
        balls.forEach(function (b) {
          var spd = Math.sqrt(b.vx * b.vx + b.vy * b.vy);
          if (spd > 0 && spd < speed * 0.35) {
            var scale = (speed * 0.35) / spd;
            b.vx *= scale;
            b.vy *= scale;
          }
        });

        requestAnimationFrame(tick);
      }

      requestAnimationFrame(tick);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.featured-article').forEach(function (el) {
      window.applyDashedHover(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('.footer__link').forEach(function (link) {
    var svg = link.querySelector('.footer__link-underline');
    if (svg) window.applyDashedLine(link, svg);
  });

  document.querySelectorAll('.footer__link--consent').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.dispatchEvent(new CustomEvent('display-privacy-banner'));
    });
  });

  var dividerWrap = document.querySelector('.footer__divider-wrap');
  if (dividerWrap) window.applyDashedLine(dividerWrap);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var NS = 'http://www.w3.org/2000/svg';

    /* ── Dashed dividers between top-level drawer items ── */
    var drawerItems = Array.from(document.querySelectorAll('.header-drawer .drawer-item'));
    drawerItems.forEach(function (item, i) {
      if (i === drawerItems.length - 1) return;
      var wrap = document.createElement('div');
      wrap.classList.add('drawer-divider-wrap');
      var svg = document.createElementNS(NS, 'svg');
      svg.classList.add('drawer-divider');
      svg.setAttribute('aria-hidden', 'true');
      wrap.appendChild(svg);
      item.insertAdjacentElement('afterend', wrap);
      window.applyDashedLine(wrap, svg);
    });

    /* ── Header scroll + drawer toggle ── */
    var header = document.querySelector('.header');
    var toggle = header && header.querySelector('.header__menu-toggle');
    var drawer = document.getElementById('header-drawer');
    if (!header || !toggle || !drawer) return;

    function openDrawer() {
      toggle.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      header.classList.add('header--drawer-open');
    }

    function closeDrawer() {
      toggle.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      header.classList.remove('header--drawer-open');
    }

    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) { closeDrawer(); } else { openDrawer(); }
    });


    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    document.addEventListener('click', function (e) {
      if (!header.contains(e.target) && !drawer.contains(e.target)) closeDrawer();
    });

    document.querySelectorAll('.drawer-parent').forEach(function (details) {
      var summary = details.querySelector('.drawer-parent__summary');
      var wrap = details.querySelector('.drawer-children-wrap');
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (details.open) {
          details.classList.add('is-closing');
          wrap.addEventListener('transitionend', function () {
            details.removeAttribute('open');
            details.classList.remove('is-closing');
          }, { once: true });
        } else {
          details.open = true;
          details.classList.add('is-opening');
          details.offsetHeight;
          details.classList.remove('is-opening');
        }
      });
    });

    var cartLink = document.getElementById('header-cart-link');
    if (cartLink) {
      cartLink.addEventListener('click', function (e) {
        if (window.CartDrawer) { e.preventDefault(); window.CartDrawer.open(); }
      });
    }

    var isOverlay = header.getAttribute('data-overlay') === 'true';
    var threshold = isOverlay ? header.offsetHeight : 20;
    function onScroll() {
      var scrolled = window.scrollY > threshold;
      header.classList.toggle('header--scrolled', scrolled);
      if (isOverlay) header.classList.toggle('header--inverted', !scrolled);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var NS = 'http://www.w3.org/2000/svg';
    var drawDashedEdge = window.drawDashedEdge;

    function renderBorder(item, svg) {
      var w = item.offsetWidth, h = item.offsetHeight;
      var media = item.querySelector('.image-grid__media');
      var mediaH = media ? media.offsetHeight : 0;
      if (!w || !h) return;
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      svg.setAttribute('width', w + 2);
      svg.setAttribute('height', h + 2);
      drawDashedEdge(svg, 1,   1,   w+1, 1);
      drawDashedEdge(svg, w+1, 1,   w+1, h+1);
      drawDashedEdge(svg, w+1, h+1, 1,   h+1);
      drawDashedEdge(svg, 1,   h+1, 1,   1);
      var dividerY = mediaH + 1;
      drawDashedEdge(svg, 1, dividerY, w+1, dividerY);
    }

    document.querySelectorAll('.image-grid__item').forEach(function (item) {
      var svg = document.createElementNS(NS, 'svg');
      svg.classList.add('dashed-border');
      svg.setAttribute('aria-hidden', 'true');
      item.appendChild(svg);
      renderBorder(item, svg);
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(function () { renderBorder(item, svg); }).observe(item);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.product-video video').forEach(function (v) {
      v.removeAttribute('controls');
      v.setAttribute('autoplay', '');
      v.setAttribute('loop', '');
      v.setAttribute('playsinline', '');
      v.muted = true;
      v.load();
      v.play().catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {

    var product = document.querySelector('.product');
    if (!product) return;

    var variantInput = product.querySelector('.product__variant-input');
    var priceEl      = product.querySelector('.product__price');
    var addBtn       = product.querySelector('.product__add-to-cart');
    var productForm  = product.querySelector('form');

    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var formData = new FormData(productForm);
        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (window.CartDrawer) window.CartDrawer.open();
          });
      });
    }

    /* ── Size swatches ── */
    product.querySelectorAll('.product__size').forEach(function (swatch) {
      window.applyDashedRect(swatch, 'product__border');
      swatch.addEventListener('click', function () {
        product.querySelectorAll('.product__size').forEach(function (s) {
          s.classList.remove('product__size--selected');
          s.setAttribute('aria-pressed', 'false');
        });
        swatch.classList.add('product__size--selected');
        swatch.setAttribute('aria-pressed', 'true');
        if (variantInput) variantInput.value = swatch.dataset.variantId;
        if (priceEl) {
          var onSale = swatch.dataset.variantOnSale === 'true';
          priceEl.classList.toggle('product__price--sale', onSale);
          var compareEl = priceEl.querySelector('.product__price-compare');
          var currentEl = priceEl.querySelector('.product__price-current');
          if (compareEl) compareEl.textContent = swatch.dataset.variantCompareAt || '';
          if (currentEl) currentEl.textContent = swatch.dataset.variantPrice;
        }
        var available = swatch.dataset.variantAvailable !== 'false';
        if (addBtn) addBtn.disabled = !available;
      });
    });

    if (addBtn) window.applyDashedRect(addBtn, 'product__border');

    document.querySelectorAll('.product__aside .accordion__divider-wrap').forEach(function (wrap) {
      window.applyDashedLine(wrap);
    });

    /* ── Lightbox ── */
    var lightbox   = document.getElementById('product-lightbox');
    var lbImg      = lightbox && lightbox.querySelector('.product__lightbox-img');
    var lbClose    = lightbox && lightbox.querySelector('.product__lightbox-close');
    var lbPrev     = lightbox && lightbox.querySelector('.product__lightbox-prev');
    var lbNext     = lightbox && lightbox.querySelector('.product__lightbox-next');
    var wraps      = Array.from(product.querySelectorAll('.product__image-wrap[data-lightbox]'));
    var lbIndex    = 0;

    function lbShow(idx) {
      lbIndex = Math.max(0, Math.min(idx, wraps.length - 1));
      var wrap = wraps[lbIndex];
      lbImg.src = wrap.dataset.lightbox;
      lbImg.alt = wrap.dataset.lightboxAlt || '';
      lbPrev.hidden = lbIndex === 0;
      lbNext.hidden = lbIndex === wraps.length - 1;
      lightbox.showModal();
    }

    wraps.forEach(function (wrap, i) {
      wrap.addEventListener('click', function () { lbShow(i); });
    });

    if (lbClose) lbClose.addEventListener('click', function () { lightbox.close(); });
    if (lbPrev)  lbPrev.addEventListener('click',  function () { lbShow(lbIndex - 1); });
    if (lbNext)  lbNext.addEventListener('click',  function () { lbShow(lbIndex + 1); });

    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) lightbox.close();
      });
      lightbox.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  lbShow(lbIndex - 1);
        if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
      });
    }

    /* ── Dashed border per image ── */
    product.querySelectorAll('.product__image-wrap').forEach(function (wrap) {
      window.applyDashedRect(wrap, 'product__image-border');
    });

    /* ── Video autoplay ── */
    product.querySelectorAll('.product__image-wrap video').forEach(function (video) {
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.playsInline = true;
      video.preload = 'auto';

      function tryPlay() {
        video.play().catch(function () {});
      }

      if (video.readyState >= 3) {
        tryPlay();
      } else {
        video.addEventListener('canplay', tryPlay, { once: true });
      }

      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          tryPlay();
        } else {
          video.pause();
        }
      }, { threshold: 0 }).observe(video);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-duo"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var NS = 'http://www.w3.org/2000/svg';

    function makeDashArray() {
      var parts = [];
      var total = 0;
      while (total < 4000) {
        var dash = 4 + Math.floor(Math.random() * 7);
        parts.push(dash, 2);
        total += dash + 2;
      }
      return parts.join(' ');
    }

    function renderBorder(item, svg, rect, dashArray) {
      var thickness = parseFloat(getComputedStyle(item).getPropertyValue('--border-thickness')) || 2;
      var w = item.offsetWidth;
      var h = item.offsetHeight;
      if (!w || !h) return;
      var offset = thickness / 2;
      svg.setAttribute('width', w);
      svg.setAttribute('height', h);
      rect.setAttribute('x', offset);
      rect.setAttribute('y', offset);
      rect.setAttribute('width', w - thickness);
      rect.setAttribute('height', h - thickness);
      rect.setAttribute('stroke-dasharray', dashArray);
    }

    document.querySelectorAll('.video-duo__item[data-border="dashed"]').forEach(function (item) {
      var dashArray = makeDashArray();

      var svg = document.createElementNS(NS, 'svg');
      svg.classList.add('video-duo__border');

      var rect = document.createElementNS(NS, 'rect');
      svg.appendChild(rect);
      item.appendChild(svg);

      renderBorder(item, svg, rect, dashArray);

      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(function () {
          renderBorder(item, svg, rect, dashArray);
        }).observe(item);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-full"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var NS = 'http://www.w3.org/2000/svg';

    function makeDashArray() {
      var parts = [];
      var total = 0;
      while (total < 8000) {
        var dash = 4 + Math.floor(Math.random() * 7);
        parts.push(dash, 2);
        total += dash + 2;
      }
      return parts.join(' ');
    }

    function renderBorder(el, svg, rect, dashArray) {
      var thickness = parseFloat(getComputedStyle(el).getPropertyValue('--border-thickness')) || 2;
      var w = el.offsetWidth;
      var h = el.offsetHeight;
      if (!w || !h) return;
      var offset = thickness / 2;
      svg.setAttribute('width', w);
      svg.setAttribute('height', h);
      rect.setAttribute('x', offset);
      rect.setAttribute('y', offset);
      rect.setAttribute('width', w - thickness);
      rect.setAttribute('height', h - thickness);
      rect.setAttribute('stroke-dasharray', dashArray);
    }

    document.querySelectorAll('.video-full[data-border="dashed"]').forEach(function (el) {
      var dashArray = makeDashArray();
      var svg = document.createElementNS(NS, 'svg');
      svg.classList.add('video-full__border');
      var rect = document.createElementNS(NS, 'rect');
      svg.appendChild(rect);
      el.appendChild(svg);
      renderBorder(el, svg, rect, dashArray);
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(function () {
          renderBorder(el, svg, rect, dashArray);
        }).observe(el);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wear-profile-feature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.baf').forEach(function (container) {
      var handle = container.querySelector('.baf__handle');
      if (!handle) return;
      var dragging = false;

      function setPos(clientX) {
        var rect = container.getBoundingClientRect();
        var pct = Math.min(98, Math.max(2, (clientX - rect.left) / rect.width * 100));
        container.style.setProperty('--pos', pct + '%');
      }

      handle.addEventListener('mousedown', function (e) {
        dragging = true;
        e.preventDefault();
      });

      handle.addEventListener('touchstart', function (e) {
        dragging = true;
        e.preventDefault();
      }, { passive: false });

      document.addEventListener('mousemove', function (e) {
        if (dragging) setPos(e.clientX);
      });

      container.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        e.preventDefault();
        setPos(e.touches[0].clientX);
      }, { passive: false });

      document.addEventListener('mouseup', function () { dragging = false; });
      document.addEventListener('touchend', function () { dragging = false; });
    });

})();

  } catch(e) { console.error(e); }
})();
})();
